import LazyImage from '../../../../../basic/lazy-image';

/**
 * 关注信息提示 Modal
 */
export default {
  name: 'FollowModal',
  props: {
    anchorPortrait: String
  },
  components: {
    'lazy-image': LazyImage
  },
  methods: {
    acceptHandler: function acceptHandler() {
      this.$emit('accept');
    },
    cancelHandler: function cancelHandler() {
      this.$emit('cancel');
    }
  }
};